import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'visitRecord/getPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'visitRecord/save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'visitRecord/delete',
    method: 'post',
    data,
  })
}
